import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_98738aa4-d15a-49a5-91ed-b440272a52f8/artifacts/7wqqh2d2_545628516_1346832964111910_2241672968598432666_n__1_-removebg-preview.png";

const navLinks = [
  { path: "/", label: "ACASA" },
  { path: "/despre-noi", label: "DESPRE NOI" },
  { path: "/servicii", label: "SERVICII" },
  { path: "/galerie", label: "GALERIE FOTO" },
  { path: "/faq", label: "FAQ" },
  { path: "/contact", label: "CONTACT" },
];

export default function Navbar() {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-md border-b border-white/10"
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center" data-testid="nav-logo">
          <img src={LOGO_URL} alt="LSK Auto Styling" className="h-12 md:h-14" />
        </Link>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              data-testid={`nav-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`text-xs tracking-[0.2em] uppercase transition-colors duration-300 ${
                location.pathname === link.path
                  ? "text-red-600 font-semibold"
                  : "text-white hover:text-red-500 font-medium"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className="lg:hidden text-white"
          onClick={() => setMobileOpen(!mobileOpen)}
          data-testid="mobile-menu-trigger"
          aria-label="Menu"
        >
          {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="lg:hidden bg-black/95 backdrop-blur-lg border-t border-white/10">
          <div className="flex flex-col px-6 py-6 gap-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileOpen(false)}
                data-testid={`mobile-nav-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                className={`text-sm tracking-[0.2em] uppercase py-2 transition-colors ${
                  location.pathname === link.path
                    ? "text-red-600 font-semibold"
                    : "text-white hover:text-red-500 font-medium"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}
